import { TradePair } from '@ui/types/tradePair';
import { Nullable } from '@ui/types/utility';
import { getProperLeverageMargin } from '@ui/utils/trade/getProperLeverageMargin';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

export const useGetProperLeverageMargin = (
  pairInfos: Nullable<TradePair>,
  leverage: Nullable<number>,
) => {
  return useMemo(() => {
    if (isNil(pairInfos?.leverageMargins) || isNil(leverage)) return undefined;
    
return getProperLeverageMargin(pairInfos.leverageMargins, leverage);
  }, [leverage, pairInfos?.leverageMargins]);
};
